module.exports = __webpack_public_path__ + "img/4.1.a520d63b.jpg";